import React, { FC } from 'react';
import { t } from 'i18next';
import cn from 'classnames';
import { Dropdown } from '@ui-modules/informed';
import { IDropdownOption } from '@ui-modules/types';
import { useNonSpammyFieldState } from '@common/hooks';
import { notEmptyValidator } from '@common/utils';
import { validateWithUser } from '../../../../../utils';
import css from '../styles.module.scss';

interface IPassengersNumberField {
  paxOptions: IDropdownOption[];
}

const PassengersNumberField: FC<IPassengersNumberField> = ({ paxOptions }) => {
  const { value: no_passengers } = useNonSpammyFieldState<boolean>('no_passengers');

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-pax-number">
      <Dropdown
        className={cn('dark-border', 'small-list')}
        isDisabled={no_passengers}
        label={t('common.pax')}
        labelClassName={css['dropdown-label']}
        name="n_of_passengers"
        options={paxOptions}
        validate={validateWithUser(notEmptyValidator)}
      />
    </div>
  );
};

export default PassengersNumberField;
